const SentinelaURL = {
  development: 'http://localhost:6003',
  staging: 'http://betalogin.tron.com.br',
  production: 'https://login.tron.com.br',
};

export default SentinelaURL;
